import React from 'react';

const ImageHolder = ({ placeholder = null, imageToRender = null, selectedIndex = 0, onImageHolderClick }) => {
	return (
        <button
            className='image-holder'
            onClick={() => onImageHolderClick(selectedIndex)}
            type='button'>
            {
				imageToRender
					? <img src={imageToRender} loading='lazy' />
					: placeholder
			}
        </button>
    );
};

export default ImageHolder;
